import { responsiveVanillaSelector } from '../selectors';
import type { Site } from '../Site';

export const FourFourTwo: Site = {
  id: 'fourfourtwo',
  logo: 'svg/fourfourtwo.svg',
  label: 'Four Four Two',
  analyticsName: 'fourfourtwo',
  hostname: 'fourfourtwo.com',
  platform: 'responsive',
  selector: responsiveVanillaSelector,
};
